import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { UploadDataService } from './upload-data.service';
import { UploadService } from './upload.service';
import { UploadComponent } from './upload.component';
import { LocalWebshopSettingsComponent } from './local-webshop-settings/local-webshop-settings.component';
import { STATE_UPLOAD_WIZARD_STEP1, STATE_UPLOAD_WIZARD_STEP2, STATE_UPLOAD_WIZARD_STEP3, STATE_UPLOAD_WIZARD_STEP4 } from '../../shared/app-states';
import { UploadStepOneComponent } from './upload-step-one.component';
import { UploadStepTwoComponent } from './upload-step-two.component';
import { UploadStepThreeComponent } from './upload-step-three.component';
import { UploadResultsComponent } from './upload-results.component';
import { UploadValidationDialogComponent } from './upload-validation-dialog.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';
import { UploadExampleTemplateComponent } from './upload-example-template.component';

const states:GaStateDeclaration[] = [
  {
    name: 'main.upload',
    url: '/upload/:code',
    component: UploadComponent,
    abstract: true,
    resolve: [
      {
        token: 'code',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.code
      }
    ]
  },
  {
    name: STATE_UPLOAD_WIZARD_STEP1,
    url: '?context',
    component: UploadStepOneComponent
  },
  {
    name: STATE_UPLOAD_WIZARD_STEP2,
    url: '/step2',
    component: UploadStepTwoComponent
  },
  {
    name: STATE_UPLOAD_WIZARD_STEP3,
    url: '/step3',
    component: UploadStepThreeComponent
  },
  {
    name: STATE_UPLOAD_WIZARD_STEP4,
    url: '/results',
    component: UploadResultsComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIRouterModule.forChild({ states })
  ],
  declarations: [
    UploadComponent,
    UploadStepOneComponent,
    UploadStepTwoComponent,
    UploadStepThreeComponent,
    UploadResultsComponent,
    UploadValidationDialogComponent,
    LocalWebshopSettingsComponent ,
    UploadExampleTemplateComponent
  ],
  providers: [
    UploadDataService,
    UploadService
  ]
})
export class UploadModule {
}